import type { MisconceptionDefinition } from './types';

/** TAA — Taalbegrip misconcepties. */
export const TAA_MISCONCEPTIONS: MisconceptionDefinition[] = [{
  id: 'taa.main-idea-vs-detail',
  label: 'Hoofdgedachte vs. detail',
  module: 'Taalbegrip',
  description: 'Leerling verwart een ondersteunend detail met de hoofdgedachte van een tekst.',
  typicalFamilies: ['TAA-LEZEN-KERN', 'TAA-LEZEN-DETAIL']
}, {
  id: 'taa.fact-vs-opinion',
  label: 'Feit vs. mening',
  module: 'Taalbegrip',
  description: 'Leerling kan geen onderscheid maken tussen feiten en meningen in een tekst.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.subject-predicate-confused',
  label: 'Onderwerp/gezegde verward',
  module: 'Taalbegrip',
  description: 'Leerling verwart het onderwerp met het gezegde in een zin.',
  typicalFamilies: ['TAA-ONT-GEZEGDE', 'TAA-ONT-BASIS']
}, {
  id: 'taa.verb-as-noun',
  label: 'Verwart werkwoord met zelfstandig naamwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een werkwoord een zelfstandig naamwoord is.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.preposition-as-noun',
  label: 'Verwart voorzetsel met zelfstandig naamwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een voorzetsel een zelfstandig naamwoord is.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.article-as-noun',
  label: 'Verwart lidwoord met zelfstandig naamwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een lidwoord een zelfstandig naamwoord is.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.de-het-confused',
  label: 'Verwart de-woord met het-woord',
  module: 'Taalbegrip',
  description: 'Leerling kent het verschil tussen de-woorden en het-woorden niet.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.article-only-een',
  label: 'Denkt dat alleen een onbepaald lidwoord is',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat alleen "een" een lidwoord is en vergeet de/het.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.no-article-needed',
  label: 'Denkt dat woorden geen lidwoord hebben',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat zelfstandige naamwoorden geen lidwoord nodig hebben.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.noun-undercount',
  label: 'Telt te weinig zelfstandige naamwoorden',
  module: 'Taalbegrip',
  description: 'Leerling mist zelfstandige naamwoorden bij het tellen.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.noun-overcount',
  label: 'Telt niet-naamwoorden mee als zelfstandig naamwoord',
  module: 'Taalbegrip',
  description: 'Leerling telt werkwoorden of voorzetsels mee als zelfstandige naamwoorden.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.noun-as-article',
  label: 'Verwart zelfstandig naamwoord met lidwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een zelfstandig naamwoord een lidwoord is.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.verb-as-article',
  label: 'Verwart werkwoord met lidwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een werkwoord een lidwoord is.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.agent-noun-as-verb',
  label: 'Verwart persoonsnaam (-er) met werkwoord',
  module: 'Taalbegrip',
  description: 'Leerling verwart een afgeleid naamwoord (fietser) met het werkwoord (fietsen).',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.noun-as-verb',
  label: 'Verwart zelfstandig naamwoord met werkwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een zelfstandig naamwoord een werkwoord is.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.preposition-as-verb',
  label: 'Verwart voorzetsel met werkwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een voorzetsel een werkwoord is.',
  typicalFamilies: ['TAA-SOORT-LID']
}, {
  id: 'taa.noun-as-adverb',
  label: 'Verwart zelfstandig naamwoord met bijwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een zelfstandig naamwoord een bijwoord is.',
  typicalFamilies: ['TAA-SOORT-BW']
}, {
  id: 'taa.verb-as-adverb',
  label: 'Verwart werkwoord met bijwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een werkwoord een bijwoord is.',
  typicalFamilies: ['TAA-SOORT-BW']
}, {
  id: 'taa.adverb-position-rule',
  label: 'Denkt dat positie in zin het verschil BNW/bijwoord bepaalt',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat de positie in de zin bepaalt of iets een BNW of bijwoord is.',
  typicalFamilies: ['TAA-SOORT-BW']
}, {
  id: 'taa.adverb-bnw-same',
  label: 'Denkt dat bijwoord en BNW dezelfde woordsoort zijn',
  module: 'Taalbegrip',
  description: 'Leerling ziet geen verschil tussen bijwoord en bijvoeglijk naamwoord.',
  typicalFamilies: ['TAA-SOORT-BW']
}, {
  id: 'taa.adverb-always-first',
  label: 'Denkt dat bijwoord altijd aan begin van zin staat',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een bijwoord altijd aan het begin van de zin staat.',
  typicalFamilies: ['TAA-SOORT-BW']
}, {
  id: 'taa.bnw-as-adverb',
  label: 'Verwart BNW bij znw met bijwoord',
  module: 'Taalbegrip',
  description: 'Leerling herkent niet dat een woord bij een zelfstandig naamwoord een BNW is, niet een bijwoord.',
  typicalFamilies: ['TAA-SOORT-BW']
}, {
  id: 'taa.adverb-place-as-time',
  label: 'Verwart bijwoord van plaats met tijd',
  module: 'Taalbegrip',
  description: 'Leerling verwart een bijwoord van plaats (waar?) met een bijwoord van tijd (wanneer?).',
  typicalFamilies: ['TAA-SOORT-BW']
}, {
  id: 'taa.adverb-manner-as-time',
  label: 'Verwart bijwoord van wijze met tijd',
  module: 'Taalbegrip',
  description: 'Leerling verwart een bijwoord van wijze (hoe?) met een bijwoord van tijd (wanneer?).',
  typicalFamilies: ['TAA-SOORT-BW']
}, {
  id: 'taa.adverb-degree-as-time',
  label: 'Verwart bijwoord van mate met tijd',
  module: 'Taalbegrip',
  description: 'Leerling verwart een bijwoord van mate met een bijwoord van tijd.',
  typicalFamilies: ['TAA-SOORT-BW']
}, {
  id: 'taa.znw-as-vnw',
  label: 'Verwart zelfstandig naamwoord met voornaamwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een zelfstandig naamwoord een voornaamwoord is.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.ww-as-vnw',
  label: 'Verwart werkwoord met voornaamwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een werkwoord een voornaamwoord is.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.vz-as-vnw',
  label: 'Verwart voorzetsel met voornaamwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een voorzetsel een voornaamwoord is.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.miss-zijn-bezittelijk',
  label: 'Herkent zijn niet als bezittelijk voornaamwoord',
  module: 'Taalbegrip',
  description: 'Leerling herkent "zijn" niet als bezittelijk voornaamwoord.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.haar-always-bezittelijk',
  label: 'Denkt dat haar altijd bezittelijk is',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "haar" altijd een bezittelijk voornaamwoord is, ook als het persoonlijk is.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.no-bezittelijk-recognized',
  label: 'Herkent geen enkel bezittelijk voornaamwoord',
  module: 'Taalbegrip',
  description: 'Leerling herkent geen enkel bezittelijk voornaamwoord in een zin.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.betrekkelijk-as-aanwijzend',
  label: 'Verwart betrekkelijk met aanwijzend voornaamwoord',
  module: 'Taalbegrip',
  description: 'Leerling verwart een betrekkelijk voornaamwoord (die/dat na znw) met een aanwijzend voornaamwoord.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.dat-as-aanwijzend',
  label: 'Verwart dat (betrekkelijk) met aanwijzend',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "dat" in een bijzin aanwijzend is in plaats van betrekkelijk.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.betrekkelijk-after-znw',
  label: 'Herkent niet dat die na een znw betrekkelijk is',
  module: 'Taalbegrip',
  description: 'Leerling herkent niet dat "die" na een zelfstandig naamwoord betrekkelijk is.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.hulpww-as-vnw',
  label: 'Verwart hulpwerkwoord met voornaamwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een hulpwerkwoord een voornaamwoord is.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.wrong-vnw-type',
  label: 'Kent juiste voornaamwoorden maar verkeerd type toe',
  module: 'Taalbegrip',
  description: 'Leerling herkent voornaamwoorden maar wijst het verkeerde type toe (persoonlijk vs bezittelijk etc.).',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.miss-het-as-vnw',
  label: 'Vergeet het als persoonlijk voornaamwoord te tellen',
  module: 'Taalbegrip',
  description: 'Leerling vergeet dat "het" ook een persoonlijk voornaamwoord kan zijn.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.miss-multiple-vnw',
  label: 'Telt meerdere voornaamwoorden niet mee',
  module: 'Taalbegrip',
  description: 'Leerling mist meerdere voornaamwoorden bij het tellen.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.overcount-vnw',
  label: 'Telt niet-voornaamwoorden mee',
  module: 'Taalbegrip',
  description: 'Leerling telt voegwoorden, bijwoorden of werkwoorden mee als voornaamwoorden.',
  typicalFamilies: ['TAA-SOORT-VNW']
}, {
  id: 'taa.noun-as-numeral',
  label: 'Verwart zelfstandig naamwoord met telwoord',
  module: 'Taalbegrip',
  description: 'Leerling kiest een zelfstandig naamwoord in plaats van het telwoord.',
  typicalFamilies: ['TAA-SOORT-TW']
}, {
  id: 'taa.verb-as-numeral',
  label: 'Verwart werkwoord met telwoord',
  module: 'Taalbegrip',
  description: 'Leerling kiest een werkwoord in plaats van het telwoord.',
  typicalFamilies: ['TAA-SOORT-TW']
}, {
  id: 'taa.cardinal-as-ordinal',
  label: 'Verwart hoofdtelwoord met rangtelwoord',
  module: 'Taalbegrip',
  description: 'Leerling kiest een hoofdtelwoord wanneer een rangtelwoord wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-TW']
}, {
  id: 'taa.compound-as-numeral',
  label: 'Verwart samenstelling met telwoord',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat samenstellingen met getallen (drietal, driedubbel) telwoorden zijn.',
  typicalFamilies: ['TAA-SOORT-TW']
}, {
  id: 'taa.miss-ordinal-as-numeral',
  label: 'Vergeet rangtelwoorden als telwoord te tellen',
  module: 'Taalbegrip',
  description: 'Leerling telt alleen hoofdtelwoorden en vergeet dat rangtelwoorden ook telwoorden zijn.',
  typicalFamilies: ['TAA-SOORT-TW']
}, {
  id: 'taa.miss-cardinal-as-numeral',
  label: 'Vergeet hoofdtelwoorden als telwoord te tellen',
  module: 'Taalbegrip',
  description: 'Leerling telt alleen rangtelwoorden en vergeet hoofdtelwoorden.',
  typicalFamilies: ['TAA-SOORT-TW']
}, {
  id: 'taa.overcount-numerals',
  label: 'Telt te veel telwoorden',
  module: 'Taalbegrip',
  description: 'Leerling telt woorden mee die geen telwoorden zijn.',
  typicalFamilies: ['TAA-SOORT-TW']
}, {
  id: 'taa.cardinal-as-numeral-only',
  label: 'Denkt dat alleen exacte getallen telwoorden zijn',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat onbepaalde hoeveelheden (veel, weinig) ook telwoorden zijn, of juist dat alleen hoofdtelwoorden tellen.',
  typicalFamilies: ['TAA-SOORT-TW']
}, {
  id: 'taa.ordinal-as-numeral-only',
  label: 'Denkt dat alleen rangtelwoorden telwoorden zijn',
  module: 'Taalbegrip',
  description: 'Leerling vergeet dat hoofdtelwoorden ook telwoorden zijn.',
  typicalFamilies: ['TAA-SOORT-TW']
}, {
  id: 'taa.preposition-as-conjunction',
  label: 'Verwart voorzetsel met voegwoord',
  module: 'Taalbegrip',
  description: 'Leerling kiest een voorzetsel wanneer een voegwoord wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.article-as-conjunction',
  label: 'Verwart lidwoord met voegwoord',
  module: 'Taalbegrip',
  description: 'Leerling kiest een lidwoord wanneer een voegwoord wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.adjective-as-conjunction',
  label: 'Verwart bijvoeglijk naamwoord met voegwoord',
  module: 'Taalbegrip',
  description: 'Leerling kiest een bijvoeglijk naamwoord wanneer een voegwoord wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.contrast-as-reason',
  label: 'Verwart tegenstelling-voegwoord met reden-voegwoord',
  module: 'Taalbegrip',
  description: 'Leerling kiest maar/hoewel wanneer omdat/want wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.choice-as-reason',
  label: 'Verwart keuze-voegwoord met reden-voegwoord',
  module: 'Taalbegrip',
  description: 'Leerling kiest of wanneer omdat wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.addition-as-reason',
  label: 'Verwart toevoeging-voegwoord met reden-voegwoord',
  module: 'Taalbegrip',
  description: 'Leerling kiest en wanneer omdat wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.miss-conjunction-en',
  label: "Vergeet 'en' als voegwoord te tellen",
  module: 'Taalbegrip',
  description: "Leerling vergeet dat 'en' een voegwoord is bij het tellen.",
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.no-conjunctions-seen',
  label: 'Herkent geen voegwoorden in de zin',
  module: 'Taalbegrip',
  description: 'Leerling ziet geen enkel voegwoord in een zin die er meerdere bevat.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.subordinating-not-conjunction',
  label: 'Denkt dat onderschikkend voegwoord geen voegwoord is',
  module: 'Taalbegrip',
  description: 'Leerling herkent onderschikkende voegwoorden (omdat, dat, als) niet als voegwoorden.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.coordinating-not-conjunction',
  label: 'Denkt dat nevenschikkend voegwoord geen voegwoord is',
  module: 'Taalbegrip',
  description: 'Leerling herkent nevenschikkende voegwoorden (maar, en, want) niet als voegwoorden.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.time-conjunction-not-conjunction',
  label: 'Denkt dat tijdsvoegwoord geen voegwoord is',
  module: 'Taalbegrip',
  description: 'Leerling herkent tijdsvoegwoorden (terwijl, toen) niet als voegwoorden.',
  typicalFamilies: ['TAA-SOORT-VW']
}, {
  id: 'taa.verb-as-preposition',
  label: 'Verwart werkwoord met voorzetsel',
  module: 'Taalbegrip',
  description: 'Leerling kiest een werkwoord wanneer een voorzetsel wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-VZ']
}, {
  id: 'taa.article-as-preposition',
  label: 'Verwart lidwoord met voorzetsel',
  module: 'Taalbegrip',
  description: 'Leerling kiest een lidwoord wanneer een voorzetsel wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-VZ']
}, {
  id: 'taa.noun-as-preposition',
  label: 'Verwart zelfstandig naamwoord met voorzetsel',
  module: 'Taalbegrip',
  description: 'Leerling kiest een zelfstandig naamwoord wanneer een voorzetsel wordt gevraagd.',
  typicalFamilies: ['TAA-SOORT-VZ']
}, {
  id: 'taa.miss-preposition-count',
  label: 'Telt niet alle voorzetsels',
  module: 'Taalbegrip',
  description: 'Leerling mist een of meer voorzetsels bij het tellen.',
  typicalFamilies: ['TAA-SOORT-VZ']
}, {
  id: 'taa.overcount-prepositions',
  label: 'Telt niet-voorzetsels mee als voorzetsel',
  module: 'Taalbegrip',
  description: 'Leerling telt lidwoorden of bijwoorden mee als voorzetsels.',
  typicalFamilies: ['TAA-SOORT-VZ']
}, {
  id: 'taa.preposition-as-non-preposition',
  label: 'Denkt dat een voorzetsel geen voorzetsel is',
  module: 'Taalbegrip',
  description: 'Leerling herkent een voorzetsel niet als zodanig.',
  typicalFamilies: ['TAA-SOORT-VZ']
}, {
  id: 'taa.preposition-place-as-time',
  label: 'Verwart plaatsvoorzetsel met tijdsvoorzetsel',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een plaatsvoorzetsel een tijdsrelatie aangeeft.',
  typicalFamilies: ['TAA-SOORT-VZ']
}, {
  id: 'taa.preposition-direction-as-time',
  label: 'Verwart richtingsvoorzetsel met tijdsvoorzetsel',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een richtingsvoorzetsel een tijdsrelatie aangeeft.',
  typicalFamilies: ['TAA-SOORT-VZ']
}, {
  id: 'taa.preposition-manner-as-time',
  label: 'Verwart maniervoorzetsel met tijdsvoorzetsel',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een maniervoorzetsel een tijdsrelatie aangeeft.',
  typicalFamilies: ['TAA-SOORT-VZ']
}, {
  id: 'taa.antonym-as-synonym',
  label: 'Verwart antoniem met synoniem',
  module: 'Taalbegrip',
  description: 'Leerling kiest het tegenovergestelde woord in plaats van een synoniem.',
  typicalFamilies: ['TAA-WOORD-SYNONIEM']
}, {
  id: 'taa.related-word-as-synonym',
  label: 'Verwart verwant woord met synoniem',
  module: 'Taalbegrip',
  description: 'Leerling kiest een woord uit hetzelfde thema maar met een andere betekenis.',
  typicalFamilies: ['TAA-WOORD-SYNONIEM']
}, {
  id: 'taa.near-synonym-not-synonym',
  label: 'Denkt dat bijna-synoniem geen synoniem is',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat woorden met een iets andere nuance geen synoniemen zijn.',
  typicalFamilies: ['TAA-WOORD-SYNONIEM']
}, {
  id: 'taa.strong-synonym-not-synonym',
  label: 'Denkt dat sterk synoniem geen synoniem is',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat woorden met een sterkere betekenis geen synoniemen zijn.',
  typicalFamilies: ['TAA-WOORD-SYNONIEM']
}, {
  id: 'taa.positive-word-in-negative-context',
  label: 'Kiest positief woord bij negatieve context',
  module: 'Taalbegrip',
  description: 'Leerling negeert negatieve contextaanwijzingen en kiest een positief woord.',
  typicalFamilies: ['TAA-WOORD-CONTEXT']
}, {
  id: 'taa.underestimate-context-clue',
  label: 'Negeert contextaanwijzing',
  module: 'Taalbegrip',
  description: 'Leerling mist een belangrijke contextaanwijzing (bijv. "verbaasd") die de betekenis bepaalt.',
  typicalFamilies: ['TAA-WOORD-CONTEXT']
}, {
  id: 'taa.opposite-meaning-context',
  label: 'Kiest tegenovergestelde betekenis',
  module: 'Taalbegrip',
  description: 'Leerling kiest een woord met de tegenovergestelde betekenis van wat de context aangeeft.',
  typicalFamilies: ['TAA-WOORD-CONTEXT']
}, {
  id: 'taa.wrong-dimension-context',
  label: 'Verwart dimensie bij contextbetekenis',
  module: 'Taalbegrip',
  description: 'Leerling kiest een woord uit een verkeerde dimensie (bijv. snelheid i.p.v. hoeveelheid).',
  typicalFamilies: ['TAA-WOORD-CONTEXT']
}, {
  id: 'taa.wrong-action-context',
  label: 'Kiest verkeerde handeling bij context',
  module: 'Taalbegrip',
  description: 'Leerling kiest een handeling die niet past bij de beschreven context.',
  typicalFamilies: ['TAA-WOORD-CONTEXT']
}, {
  id: 'taa.neutral-word-for-emotional',
  label: 'Kiest neutraal woord bij emotionele context',
  module: 'Taalbegrip',
  description: 'Leerling kiest een neutraal woord terwijl de context een emotionele situatie beschrijdt.',
  typicalFamilies: ['TAA-WOORD-CONTEXT']
}, {
  id: 'taa.idioom-letterlijk-cadeau',
  label: 'Neemt uitdrukking letterlijk (cadeau)',
  module: 'Taalbegrip',
  description: 'Leerling interpreteert "hart onder de riem steken" als cadeau geven.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-letterlijk-riem',
  label: 'Neemt uitdrukking letterlijk (riem)',
  module: 'Taalbegrip',
  description: 'Leerling interpreteert "hart onder de riem steken" als riem lenen.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-letterlijk-steken',
  label: 'Neemt steken letterlijk (pijn)',
  module: 'Taalbegrip',
  description: 'Leerling interpreteert "steken" als pijn doen.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-letterlijk-buikpijn',
  label: 'Neemt uitdrukking letterlijk (buikpijn)',
  module: 'Taalbegrip',
  description: 'Leerling interpreteert "vlinders in je buik" als buikpijn.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-letterlijk-vlinders',
  label: 'Neemt uitdrukking letterlijk (echte vlinders)',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat er echte vlinders zijn gezien.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-letterlijk-honger',
  label: 'Verwart buikgevoel met honger',
  module: 'Taalbegrip',
  description: 'Leerling interpreteert "vlinders in je buik" als honger.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-verwisseld-boter',
  label: 'Verwart neus-in-boter met hard werken',
  module: 'Taalbegrip',
  description: 'Leerling verwart "met je neus in de boter vallen" (geluk) met hard werken.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-verwisseld-spijker',
  label: 'Verwart spijker-op-kop met hard werken',
  module: 'Taalbegrip',
  description: 'Leerling verwart "de spijker op de kop slaan" (goed raden) met hard werken.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-verwisseld-mand',
  label: 'Verwart door-de-mand met hard werken',
  module: 'Taalbegrip',
  description: 'Leerling verwart "door de mand vallen" (betrapt worden) met hard werken.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-letterlijk-olifant-sterk',
  label: 'Neemt olifant letterlijk (sterk)',
  module: 'Taalbegrip',
  description: 'Leerling interpreteert "van een mug een olifant maken" als sterk zijn.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-letterlijk-olifant-slim',
  label: 'Interpreteert mug-olifant als slim',
  module: 'Taalbegrip',
  description: 'Leerling interpreteert "van een mug een olifant maken" als slim zijn.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.idioom-letterlijk-olifant-luid',
  label: 'Interpreteert mug-olifant als luidruchtig',
  module: 'Taalbegrip',
  description: 'Leerling interpreteert "van een mug een olifant maken" als luidruchtig zijn.',
  typicalFamilies: ['TAA-WOORD-IDIOOM']
}, {
  id: 'taa.detail-as-main-idea',
  label: 'Detail aanzien voor hoofdgedachte',
  module: 'Taalbegrip',
  description: 'Leerling verwart een detail of gevolg met de hoofdgedachte van de tekst.',
  typicalFamilies: ['TAA-LEZEN-KERN']
}, {
  id: 'taa.outside-knowledge',
  label: 'Eigen kennis invullen i.p.v. tekst lezen',
  module: 'Taalbegrip',
  description: 'Leerling baseert antwoord op eigen kennis of mening in plaats van op de tekst.',
  typicalFamilies: ['TAA-LEZEN-KERN', 'TAA-LEZEN-DETAIL']
}, {
  id: 'taa.adding-to-source',
  label: 'Informatie toevoegen die niet in de tekst staat',
  module: 'Taalbegrip',
  description: 'Leerling kiest een antwoord dat informatie bevat die niet in de brontekst staat.',
  typicalFamilies: ['TAA-LEZEN-KERN']
}, {
  id: 'taa.exaggeration',
  label: 'Overdrijving van een detail uit de tekst',
  module: 'Taalbegrip',
  description: 'Leerling kiest een antwoord dat een detail uit de tekst overdrijft.',
  typicalFamilies: ['TAA-LEZEN-KERN']
}, {
  id: 'taa.opposite-meaning',
  label: 'Tegenovergestelde van wat de tekst zegt',
  module: 'Taalbegrip',
  description: 'Leerling kiest een antwoord dat het tegenovergestelde beweert van wat de tekst aangeeft.',
  typicalFamilies: ['TAA-LEZEN-KERN']
}, {
  id: 'taa.partial-reading',
  label: 'Alleen een deel van de tekst gelezen',
  module: 'Taalbegrip',
  description: 'Leerling baseert antwoord op slechts een deel van de tekst (alleen positief of negatief).',
  typicalFamilies: ['TAA-LEZEN-KERN']
}, {
  id: 'taa.title-too-vague',
  label: 'Titel te vaag — dekt de kern niet',
  module: 'Taalbegrip',
  description: 'Leerling kiest een titel die te breed of vaag is om de inhoud te dekken.',
  typicalFamilies: ['TAA-LEZEN-KERN']
}, {
  id: 'taa.wrong-number-from-text',
  label: 'Verkeerd getal uit tekst gekozen',
  module: 'Taalbegrip',
  description: 'Leerling koppelt het verkeerde getal aan de gevraagde informatie (bijv. bouwjaar i.p.v. hoogte).',
  typicalFamilies: ['TAA-LEZEN-DETAIL']
}, {
  id: 'taa.imprecise-reading',
  label: 'Tekst onnauwkeurig gelezen',
  module: 'Taalbegrip',
  description: 'Leerling leest een getal of woord onnauwkeurig (bijv. 300 i.p.v. 330).',
  typicalFamilies: ['TAA-LEZEN-DETAIL']
}, {
  id: 'taa.synonym-confusion',
  label: 'Verwart vergelijkbare maar verschillende termen',
  module: 'Taalbegrip',
  description: 'Leerling verwart een term met een vergelijkbaar maar ander woord (bijv. blaasgat vs. neus).',
  typicalFamilies: ['TAA-LEZEN-DETAIL']
}, {
  id: 'taa.misleading-detail',
  label: 'Afleidende informatie uit tekst',
  module: 'Taalbegrip',
  description: 'Leerling laat zich afleiden door een detail dat lijkt op het antwoord maar het niet is (bijv. heviger ≠ meer).',
  typicalFamilies: ['TAA-LEZEN-DETAIL']
}, {
  id: 'taa.answer-not-in-text',
  label: 'Antwoord niet in tekst',
  module: 'Taalbegrip',
  description: 'Leerling kiest een antwoord dat niet in de tekst wordt genoemd.',
  typicalFamilies: ['TAA-LEZEN-DETAIL']
}, {
  id: 'taa.confuses-old-and-modern',
  label: 'Verwart eerste en moderne variant',
  module: 'Taalbegrip',
  description: 'Leerling verwart informatie over de oorspronkelijke en moderne versie van iets.',
  typicalFamilies: ['TAA-LEZEN-DETAIL']
}, {
  id: 'taa.wrong-question-type',
  label: 'Antwoordt op verkeerd vraagtype',
  module: 'Taalbegrip',
  description: 'Leerling beantwoordt een waar-vraag met wanneer of hoe vaak, of andersom.',
  typicalFamilies: ['TAA-LEZEN-DETAIL']
}, {
  id: 'taa.feit-mening-regels-als-feiten',
  label: 'Verwart spelregels (feiten) met meningen',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat controleerbare spelregels meningen zijn.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-historie-als-feit',
  label: 'Verwart historische feiten met meningen',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat controleerbare historische gebeurtenissen meningen zijn.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-aantallen-als-feiten',
  label: 'Verwart controleerbare aantallen met meningen',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat controleerbare getallen of aantallen meningen zijn.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-overtr-trap',
  label: 'Herkent overtreffende trap niet als meningssignaal',
  module: 'Taalbegrip',
  description: 'Leerling herkent niet dat de overtreffende trap (het mooiste, het beste) een waardeoordeel is.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-zou-moeten',
  label: 'Herkent "zou moeten" niet als meningssignaal',
  module: 'Taalbegrip',
  description: 'Leerling herkent niet dat "zou moeten" een persoonlijke overtuiging aangeeft.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-superlative',
  label: 'Herkent superlative niet als waardeoordeel',
  module: 'Taalbegrip',
  description: 'Leerling herkent niet dat "het fijnste", "het leukste" etc. waardeoordelen zijn.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-twee-feiten',
  label: 'Verwart twee feiten in één zin met feit+mening',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een zin met twee controleerbare feiten automatisch feit+mening bevat.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-ik-vind-geen-feit',
  label: 'Denkt dat "ik vind" automatisch feit+mening maakt',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "ik vind" in een zin automatisch betekent dat er ook een feit in staat.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-sterke-bewering',
  label: 'Verwart sterke bewering met feit+mening',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een sterke bewering (de beste) automatisch een feit bevat.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.signaal-opsomming-vs-mening',
  label: 'Verwart opsommingssignaalwoord met meningssignaalwoord',
  module: 'Taalbegrip',
  description: 'Leerling verwart "ten eerste" (opsomming) met een meningssignaalwoord.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.signaal-voorbeeld-vs-mening',
  label: 'Verwart voorbeeldsignaalwoord met meningssignaalwoord',
  module: 'Taalbegrip',
  description: 'Leerling verwart "bijvoorbeeld" (voorbeeld) met een meningssignaalwoord.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.signaal-uitleg-vs-mening',
  label: 'Verwart uitlegsignaalwoord met meningssignaalwoord',
  module: 'Taalbegrip',
  description: 'Leerling verwart "namelijk" (uitleg) met een meningssignaalwoord.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-data-als-feit',
  label: 'Verwart controleerbare data met mening',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat controleerbare data (jaartallen, getallen) meningen zijn.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-werkstuk-alles-feit',
  label: 'Denkt dat alles in een werkstuk een feit is',
  module: 'Taalbegrip',
  description: 'Leerling gaat ervan uit dat alles in een werkstuk automatisch een feit is.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.feit-mening-alles-mening',
  label: 'Denkt dat alles een mening is',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat alle uitspraken meningen zijn, ook controleerbare feiten.',
  typicalFamilies: ['TAA-LEZEN-FEIT']
}, {
  id: 'taa.doel-informeren-vs-overtuigen',
  label: 'Verwart informeren met overtuigen',
  module: 'Taalbegrip',
  description: 'Leerling herkent niet dat een oproep of mening wijst op overtuigen, niet informeren.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.doel-vermaken-vs-overtuigen',
  label: 'Verwart vermaken met overtuigen',
  module: 'Taalbegrip',
  description: 'Leerling verwart een overtuigende tekst met een vermakelijke tekst.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.doel-waarschuwen-vs-overtuigen',
  label: 'Verwart waarschuwen met overtuigen',
  module: 'Taalbegrip',
  description: 'Leerling verwart een overtuigende tekst met een waarschuwende tekst.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.doel-overtuigen-vs-informeren',
  label: 'Verwart overtuigen met informeren',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een neutrale informatieve tekst overtuigend is.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.doel-vermaken-vs-informeren',
  label: 'Verwart vermaken met informeren',
  module: 'Taalbegrip',
  description: 'Leerling verwart een informatieve tekst met een vermakelijke tekst.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.doel-instrueren-vs-informeren',
  label: 'Verwart instrueren met informeren',
  module: 'Taalbegrip',
  description: 'Leerling verwart een informatieve tekst met een instructietekst.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.signaal-opsomming-vs-overtuigen',
  label: 'Verwart opsommingssignaal met overtuigingssignaal',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "ten eerste" een overtuigingssignaalwoord is.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.signaal-verhaal-vs-overtuigen',
  label: 'Verwart verhaalsignaal met overtuigingssignaal',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "er was eens" een overtuigingssignaalwoord is.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.signaal-instructie-vs-overtuigen',
  label: 'Verwart instructiesignaal met overtuigingssignaal',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "voeg toe" een overtuigingssignaalwoord is.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.doel-neutraal-als-overtuigen-voor',
  label: 'Denkt dat voor+nadelen = overtuigen vóór',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een neutrale tekst met voor- en nadelen overtuigt vóór het onderwerp.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.doel-neutraal-als-overtuigen-tegen',
  label: 'Denkt dat voor+nadelen = overtuigen tegen',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een neutrale tekst met voor- en nadelen overtuigt tegen het onderwerp.',
  typicalFamilies: ['TAA-LEZEN-DOEL']
}, {
  id: 'taa.samenvatting-te-smal',
  label: 'Kiest detail i.p.v. samenvatting',
  module: 'Taalbegrip',
  description: 'Leerling kiest een detail als samenvatting in plaats van de overkoepelende hoofdgedachte.',
  typicalFamilies: ['TAA-LEZEN-SAMENVATTEN']
}, {
  id: 'taa.samenvatting-hoofdgedachte-weglaten',
  label: 'Denkt dat hoofdgedachte niet in samenvatting hoort',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat de hoofdgedachte niet in een samenvatting thuishoort.',
  typicalFamilies: ['TAA-LEZEN-SAMENVATTEN']
}, {
  id: 'taa.samenvatting-punten-weglaten',
  label: 'Denkt dat belangrijkste punten niet in samenvatting horen',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat de belangrijkste punten per alinea niet in een samenvatting horen.',
  typicalFamilies: ['TAA-LEZEN-SAMENVATTEN']
}, {
  id: 'taa.samenvatting-conclusie-weglaten',
  label: 'Denkt dat conclusie niet in samenvatting hoort',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat de conclusie van de schrijver niet in een samenvatting hoort.',
  typicalFamilies: ['TAA-LEZEN-SAMENVATTEN']
}, {
  id: 'taa.samenvatting-eigen-mening',
  label: 'Denkt dat samenvatten begint met eigen mening',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat je bij samenvatten begint met je eigen mening opschrijven.',
  typicalFamilies: ['TAA-LEZEN-SAMENVATTEN']
}, {
  id: 'taa.samenvatting-alle-details',
  label: 'Denkt dat alle details opgeschreven moeten worden',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een samenvatting alle details moet bevatten.',
  typicalFamilies: ['TAA-LEZEN-SAMENVATTEN']
}, {
  id: 'taa.samenvatting-overschrijven',
  label: 'Verwart samenvatten met overschrijven',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat samenvatten hetzelfde is als de tekst letterlijk overschrijven.',
  typicalFamilies: ['TAA-LEZEN-SAMENVATTEN']
}, {
  id: 'taa.structuur-oorzaak-vs-probleem',
  label: 'Verwart oorzaak-gevolg met probleem-oplossing',
  module: 'Taalbegrip',
  description: 'Leerling verwart de oorzaak-gevolgstructuur met de probleem-oplossingstructuur.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.structuur-vergelijking-vs-probleem',
  label: 'Verwart vergelijking met probleem-oplossing',
  module: 'Taalbegrip',
  description: 'Leerling verwart de vergelijkingsstructuur met de probleem-oplossingstructuur.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.structuur-chronologisch-vs-probleem',
  label: 'Verwart chronologisch met probleem-oplossing',
  module: 'Taalbegrip',
  description: 'Leerling verwart de chronologische structuur met de probleem-oplossingstructuur.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.signaal-opsomming-vs-oorzaak',
  label: 'Verwart opsommingssignaal met oorzaak-gevolg',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "ten eerste" een oorzaak-gevolg signaalwoord is.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.signaal-tegenstelling-vs-oorzaak',
  label: 'Verwart tegenstellingssignaal met oorzaak-gevolg',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "in tegenstelling tot" een oorzaak-gevolg signaalwoord is.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.signaal-chronologisch-vs-oorzaak',
  label: 'Verwart chronologisch signaal met oorzaak-gevolg',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "ten slotte" een oorzaak-gevolg signaalwoord is.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.structuur-opsomming-vs-vergelijking',
  label: 'Verwart opsomming met vergelijking',
  module: 'Taalbegrip',
  description: 'Leerling verwart de opsommingsstructuur met de vergelijkingsstructuur.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.structuur-probleem-vs-vergelijking',
  label: 'Verwart probleem-oplossing met vergelijking',
  module: 'Taalbegrip',
  description: 'Leerling verwart de probleem-oplossingstructuur met de vergelijkingsstructuur.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.structuur-oorzaak-vs-vergelijking',
  label: 'Verwart oorzaak-gevolg met vergelijking',
  module: 'Taalbegrip',
  description: 'Leerling verwart de oorzaak-gevolgstructuur met de vergelijkingsstructuur.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.structuur-oorzaak-vs-chronologisch',
  label: 'Verwart oorzaak-gevolg met chronologisch',
  module: 'Taalbegrip',
  description: 'Leerling verwart de oorzaak-gevolgstructuur met de chronologische structuur.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.structuur-vergelijking-vs-chronologisch',
  label: 'Verwart vergelijking met chronologisch',
  module: 'Taalbegrip',
  description: 'Leerling verwart de vergelijkingsstructuur met de chronologische structuur.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.structuur-probleem-vs-chronologisch',
  label: 'Verwart probleem-oplossing met chronologisch',
  module: 'Taalbegrip',
  description: 'Leerling verwart de probleem-oplossingstructuur met de chronologische structuur.',
  typicalFamilies: ['TAA-LEZEN-STRUCTUUR']
}, {
  id: 'taa.verb-tegenstelling-vs-oorzaak',
  label: 'Verwart tegenstelling met oorzaak-gevolg',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een tegenstellingssignaalwoord (maar, toch) een oorzaak-gevolg aangeeft.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-tegenstelling-vs-gevolg',
  label: 'Verwart tegenstelling met gevolg',
  module: 'Taalbegrip',
  description: 'Leerling kiest een gevolg-signaalwoord (dus) als tegenstelling.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-tegenstelling-vs-toevoeging',
  label: 'Verwart tegenstelling met toevoeging',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een toevoegingswoord (ook) een tegenstelling aangeeft.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-tegenstelling-vs-opsomming',
  label: 'Verwart tegenstelling met opsomming',
  module: 'Taalbegrip',
  description: 'Leerling verwart een tegenstellingsverband met een opsommingsverband.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-tegenstelling-vs-tijdsvolgorde',
  label: 'Verwart tegenstelling met tijdsvolgorde',
  module: 'Taalbegrip',
  description: 'Leerling verwart een tegenstellingsverband met een tijdsvolgordeverband.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-oorzaak-vs-tegenstelling',
  label: 'Verwart oorzaak-gevolg met tegenstellingsverband',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een oorzaak-gevolgsignaalwoord (daardoor) een tegenstelling aangeeft.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-oorzaak-vs-vergelijking',
  label: 'Verwart oorzaak-gevolg met vergelijking',
  module: 'Taalbegrip',
  description: 'Leerling verwart een oorzaak-gevolgverband met een vergelijkingsverband.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-oorzaak-vs-opsomming',
  label: 'Verwart oorzaak-gevolg met opsomming',
  module: 'Taalbegrip',
  description: 'Leerling verwart een oorzaak-gevolgverband met een opsommingsverband.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-opsomming-vs-tegenstelling',
  label: 'Verwart opsomming met tegenstelling',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een opsommingssignaalwoord (bovendien) een tegenstelling aangeeft.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-opsomming-vs-oorzaak',
  label: 'Verwart opsomming met oorzaak-gevolg',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een opsommingssignaalwoord een oorzaak-gevolg aangeeft.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verb-opsomming-vs-tijdsvolgorde',
  label: 'Verwart opsomming met tijdsvolgorde',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een opsommingssignaalwoord een tijdsvolgorde aangeeft.',
  typicalFamilies: ['TAA-LEZEN-VERB']
}, {
  id: 'taa.verw-daar-naar-persoon',
  label: 'Verwart plaatsverwijswoord met persoonsverwijzing',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "daar" naar een persoon verwijst in plaats van naar een plaats.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.verw-daar-naar-object',
  label: 'Verwart plaatsverwijswoord met objectverwijzing',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "daar" naar een voorwerp verwijst in plaats van naar een plaats.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.verw-ze-naar-plaats',
  label: 'Verwart persoonsverwijzing met plaatsverwijzing',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "ze" naar een plaats verwijst in plaats van naar personen.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.verw-ze-naar-tijd',
  label: 'Verwart persoonsverwijzing met tijdsaanduiding',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "ze" naar een tijdsaanduiding verwijst.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.verw-hem-naar-onderwerp',
  label: 'Verwart lijdend-voorwerp-verwijzing met onderwerpverwijzing',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "hem" naar het onderwerp verwijst terwijl "hij" dat al doet.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.verw-hem-niet-in-tekst',
  label: 'Verwijst naar woord buiten de tekst',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat een verwijswoord naar iets verwijst dat niet in de tekst staat.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.verw-dat-naar-persoon',
  label: 'Verwart "dat" met persoonsverwijzing',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "dat" naar een persoon verwijst in plaats van naar een handeling.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.verw-dat-naar-object-ipv-handeling',
  label: 'Verwart "dat" als objectverwijzing i.p.v. handelingsverwijzing',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "dat" naar een enkel object verwijst terwijl het naar een hele handeling verwijst.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.verw-zij-enkelvoud-vs-meervoud',
  label: 'Verwart "zij" enkelvoud met meervoud',
  module: 'Taalbegrip',
  description: 'Leerling herkent niet dat "zij" zowel enkelvoud (vrouwelijk) als meervoud kan zijn.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.verw-zij-naar-niet-persoon',
  label: 'Verwart "zij" met niet-persoonsverwijzing',
  module: 'Taalbegrip',
  description: 'Leerling denkt dat "zij" naar een voorwerp of begrip verwijst in plaats van naar personen.',
  typicalFamilies: ['TAA-LEZEN-VERW']
}, {
  id: 'taa.voorspel-enkele-aanwijzing',
  label: 'Baseert voorspelling op één aanwijzing',
  module: 'Taalbegrip',
  description: 'Leerling baseert de voorspelling op slechts één aanwijzing en negeert de overige.',
  typicalFamilies: ['TAA-LEZEN-VOORSPEL']
}, {
  id: 'taa.voorspel-extreme-conclusie',
  label: 'Trekt een te extreme conclusie',
  module: 'Taalbegrip',
  description: 'Leerling kiest een extreme of onwaarschijnlijke voorspelling in plaats van de meest logische.',
  typicalFamilies: ['TAA-LEZEN-VOORSPEL']
}, {
  id: 'taa.voorspel-negatief-bias',
  label: 'Negatieve bias bij voorspellen',
  module: 'Taalbegrip',
  description: 'Leerling verwacht een negatieve uitkomst terwijl de aanwijzingen positief zijn.',
  typicalFamilies: ['TAA-LEZEN-VOORSPEL']
}, {
  id: 'taa.voorspel-niet-in-tekst',
  label: 'Voorspelling niet gebaseerd op tekst',
  module: 'Taalbegrip',
  description: 'Leerling maakt een voorspelling die niet ondersteund wordt door aanwijzingen in de tekst.',
  typicalFamilies: ['TAA-LEZEN-VOORSPEL']
}, {
  id: 'taa.voorspel-genre-verwarring',
  label: 'Verwart tekstgenre bij voorspellen',
  module: 'Taalbegrip',
  description: 'Leerling verwart het genre van de tekst (verhalend vs instructief vs wetenschappelijk).',
  typicalFamilies: ['TAA-LEZEN-VOORSPEL']
}, {
  id: 'taa.voorspel-titel-letterlijk',
  label: 'Neemt titel te letterlijk',
  module: 'Taalbegrip',
  description: 'Leerling interpreteert de titel te letterlijk zonder de bredere betekenis te zien.',
  typicalFamilies: ['TAA-LEZEN-VOORSPEL']
}, {
  id: 'taa.voorspel-aanwijzing-negeren',
  label: 'Negeert relevante aanwijzingen',
  module: 'Taalbegrip',
  description: 'Leerling negeert een of meer relevante aanwijzingen bij het maken van een voorspelling.',
  typicalFamilies: ['TAA-LEZEN-VOORSPEL']
}, {
  id: 'taa.conclusie-overgeneralisatie',
  label: 'Overgeneraliseert bij conclusie',
  module: 'Taalbegrip',
  description: 'Leerling trekt een te brede conclusie die verder gaat dan de feiten ondersteunen.',
  typicalFamilies: ['TAA-LEZEN-CONCLUSIE']
}, {
  id: 'taa.conclusie-niet-in-tekst',
  label: 'Conclusie niet gebaseerd op tekst',
  module: 'Taalbegrip',
  description: 'Leerling trekt een conclusie die niet ondersteund wordt door de tekst.',
  typicalFamilies: ['TAA-LEZEN-CONCLUSIE']
}];